import 'appstart';
//import 'SCSSEntries/hotelReviews.scss';
//import 'Vendors/knockout/knockout-pack';
//import { GetBreakpointWidth } from 'Utils/globals-bp';
//import { isTouch, isApplePie, is_iPhone, IsPortraitMode, IsLandscapeMode, DetectIE } from 'Utils/device-utils';
//import { SetHotelRoomsTooltips } from 'Utils/ha-mytriplogic-functions';
//import { UpdateSiteHeaderSticky } from 'Modules/headroom.js';

//global.SetHotelRoomsTooltips = SetHotelRoomsTooltips;

//global.isTouch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|windows phone|WindowsPhone/i.test(navigator.userAgent.toLowerCase());
//global.isApplePie = /iPhone|iPad|iPod/i.test(navigator.userAgent.toLowerCase());
//global.is_iPhone = /iPhone/i.test(navigator.userAgent.toLowerCase());

//import 'Utils/formatters';


//import 'SrcJS/knockout-extensions/knockout.spinner';

//import 'Utils/mere.js';
//import 'Utils/slider.js'; //??? //2021-06-14 Disabled
//import 'Modules/map-container';
//import 'Modules/hotel-mapbox';

//import(/* webpackChunkName: "searchbar-module" */ 'searchbar');
//import(/* webpackChunkName: "search-single-result-module" */ 'search-single-result');

function InitScript_hotelreviews() {
    $(document).on('click', '.review-lang-link', function (event) {
        event.preventDefault();

        var r = $(this).attr("data-review-id");
        var o_l = $(this).attr("data-original-lang");
        var l = $(this).attr("data-lang");

        var url = String.format("/hotels/review/{0}?pageId={1}&l={2}&o_l={3}",
            r, AppData.CurrentPageId, l, o_l
        );
        url = url + "&sid=" + Math.random();
        $.ajax({
            type: "GET",
            url: url,
            beforeSend: function () { },
            success: function (data) {
                var $review = $("#review" + r);
                $review.html(data)
                update_lazysizes($review);
                update_slimmage();
            }
        });
    });

    $(document).on('click', '.more-hotel-reviews-link', function (event) {
        event.preventDefault();
        let $this = $(this);

        if ($this.data("requesting") == true)
            return;

        $this.data("requesting", true);

        let lastCount = $this.attr("data-LastCount");
        let nextCount = $this.attr("data-NextCount");
        let totalItems = $this.attr("data-TotalItems");

        var url = String.format("/hotels/reviews/{0}?pageId={1}&skip={2}&size={3}&totalItems={4}",
            AppData.CurrentPageId,
            AppData.CurrentPageId,
            lastCount,
            nextCount,
            totalItems
        );
        url = url + "&sid=" + Math.random();
        $.ajax({
            type: "GET",
            url: url,
            beforeSend: function () { },
            success: function (data) {
                let $holder = $this.closest('.more-hotel-reviews-holder');
                let $parent = $holder.parent();
                let $data = $($.parseHTML(data));
                $holder.remove();
                $data.appendTo($parent);
                update_lazysizes($data);
                update_slimmage();
            },
            error: function (data, textStatus, errorThrown) {

            }
        }).always(function () {
            $this.data("requesting", false);
        });
    });

    function update_lazysizes($review) {
        let $images = $review.find('img, .lazyload');
        if ($images && $images.length > 0) {
            $images.each(function (i, el) {
                if (el.hasClass('lazydefer')) {
                    el.removeClass('lazydefer');
                }
                el.style.removeProperty('visibility');
                el.style.removeProperty('display');
            });
        }
    }

    function update_slimmage() {
        if (window.slimmage.checkResponsiveImages) {
            window.slimmage.checkResponsiveImages();
        }

        if (typeof imgix !== "undefined") {
            imgix.init();
        }

        if (typeof lazySizes !== "undefined") {
            lazySizes.loader.checkElems();
        }
    }
};

AppLoader.loaded(InitScript_hotelreviews);

//AppLoader.setReady();